<script>
  import { BaseEdge, EdgeLabel } from "@xyflow/svelte";
  import * as d3 from "d3";

  export let data;
  export let markerEnd;
  let { points, label, casesView } = data;
  let path;
  let labelPosition;

  $$restProps;

  $: labelPosition = calculateLabelPosition(points);
  $: path = createEdgePath(points);

  function createEdgePath(points) {
    const line = d3
      .line()
      .curve(d3.curveMonotoneY)
      .x((d) => d.x)
      .y((d) => d.y);

    return line(points);
  }

  function calculateLabelPosition(points) {
    const middleIndex = Math.floor(points.length / 2);
    if (points.length % 2 === 0) {
      // If even number of points, take the average of the two middle points
      const midX = (points[middleIndex - 1].x + points[middleIndex].x) / 2;
      const midY = (points[middleIndex - 1].y + points[middleIndex].y) / 2;
      return { x: midX, y: midY };
    } else {
      // If odd number of points, take the middle point
      return { x: points[middleIndex].x, y: points[middleIndex].y };
    }
  }
</script>

<BaseEdge {path} {markerEnd} style="stroke-width: 2; stroke:black;" />
<EdgeLabel>
  <div
    style:transform="translate(-50%, -50%) translate({labelPosition.x}px,{labelPosition.y}px)"
    class="edge-label"
  >
    {label}{casesView ? "" : "%"}
  </div>
</EdgeLabel>

<style>
  .edge-label {
    position: absolute;
    font-size: 14px;
    border: 1px solid #000;
    border-radius: 5px;
    background: white;
    color: #000;
    padding: 3px;
    display: inline-block;
  }
  :global(.svelte-flow__edgelabel-renderer) {
    z-index: 100 !important;
  }

  :global(.svelte-flow__edges) {
    z-index: 50 !important;
    opacity: 0.6;
  }
</style>
